import { render, staticRenderFns } from "./FreePriceDetailComponent.vue?vue&type=template&id=6d69515f&scoped=true&"
import script from "./FreePriceDetailComponent.vue?vue&type=script&lang=js&"
export * from "./FreePriceDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d69515f",
  null
  
)

export default component.exports